import qtAnalytics, { handleImpressions } from '../quote-tool/components/qtAnalytics';
import { aiUrl } from './apiProxy';

export default function ai() {
	// handle uploading photo
	let vinImageUpload = document.querySelector('#vinImageUpload');
	if (!vinImageUpload) return;

	let vinModal = document.querySelector('.c-modal--vin');

	let applyVinNumber = vinModal.querySelector('.js-apply-vin-number-to-field');

	if (applyVinNumber) {
		applyVinNumber.addEventListener('click', function () {
			let vinNumberValue = vinModal.querySelector('#vinNumber').innerHTML;
			let vinNumberHolder = document.querySelector('#vin');
			vinNumberHolder.value = vinNumberValue;
			if(toolType === 'quote') {
				qtAnalytics('ai-vehicle-information-ai-upload-validation-confirmation-submit', '', 4.4, toolType);
			}
			if(toolType === 'appointment') {
				qtAnalytics('ai-vehicle-information-ai-upload-validation-confirmation-submit', '', 2.4, toolType);
			}
			closeVinModal();
		});
	}

	let toolType = '';

	// if class exists .appointment-tool toolType is appointment
	if (document.querySelector('#appointment-tool')) {
		toolType = 'appointment';
	}

	// if class exists .quote-tool toolType is quote
	if (document.querySelector('#quote-tool')) {
		toolType = 'quote';
	}

	// Find all .s-open-vin-modal and closeModal
	let openVinModalTriggers = document.querySelectorAll('.js-open-vin-modal');
	let closeVinModalTriggers = document.querySelectorAll('.js-close-vin-modal');

	if (openVinModalTriggers.length > 0) {
		openVinModalTriggers.forEach((openVin) => {
			openVin.addEventListener('click', function () {
				resetModal();
				openVinModal();

				if (toolType === 'quote') {
					qtAnalytics('ai-vehicle-information-ai-start', '', 4.1, toolType);
				}
				if (toolType === 'appointment') {
					qtAnalytics('ai-vehicle-information-ai-start', '', 2.1, toolType);
				}
			});
		});
	}

	if (closeVinModalTriggers.length > 0) {
		closeVinModalTriggers.forEach((closeVin) => {
			closeVin.addEventListener('click', function () {
				closeVinModal();
				resetModal();
			});
		});
	}

	let steps = {
		info: 'c-modal__upload--info',
		start: 'c-modal__upload--start',
		verify: 'c-modal__upload--verify',
		uploading: 'c-modal__upload--uploading',
		services: 'c-modal__upload--services',
	};

	function resetModal() {
		let uploaderError = vinModal.querySelector('.c-modal__upload-status--error');
		if (uploaderError) {
			uploaderError.classList.remove('active');
		}

		let uploaderFailed = vinModal.querySelector('.c-modal__uploader.failed');
		if (uploaderFailed) {
			uploaderFailed.classList.remove('failed');
		}

		// Progress bar width to 1%
		let dashboardImageUploadProgress = vinModal.querySelector('#vinImageProgress');
		if (dashboardImageUploadProgress) {
			dashboardImageUploadProgress.style.width = '1%';
		}

		let errorButtons = vinModal.querySelectorAll('.c-modal__upload-buttons--error.active');
		if (errorButtons.length > 0) {
			errorButtons.forEach((button) => button.classList.remove('active'));
		}

		let uploadSuccess = vinModal.querySelector('.c-modal__upload-status--success');
		if (uploadSuccess) {
			uploadSuccess.classList.remove('active');
		}
		let buttonSuccess = vinModal.querySelector('.c-modal__upload-buttons--success');
		if (buttonSuccess) {
			buttonSuccess.classList.remove('active');
		}

		let uploadStart = vinModal.querySelector('.c-modal__upload--start');
		if (uploadStart) {
			uploadStart.classList.remove('active');
		}
		let uploadStartUploading = vinModal.querySelector('.c-modal__upload-status--uploading');
		if (uploadStartUploading) {
			uploadStartUploading.classList.add('active');
		}

		let vinStart = vinModal.querySelector('.c-modal__upload--info');
		if (vinStart) {
			vinStart.classList.add('active');
		}

		let uploader = vinModal.querySelector('.c-modal__uploader');
		if (uploader) {
			uploader.classList.remove('active');
		}
		let uploading = vinModal.querySelector('.c-modal__upload--uploading');
		if (uploading) {
			uploading.classList.remove('active');
		}

		// Reset file input
		let dashboardImageUpload = vinModal.querySelector('#vinImageUpload');
		if (dashboardImageUpload) {
			dashboardImageUpload.value = '';
		}

		// Remove image preview
		let imagePreview = vinModal.querySelector('#vinImagePreview');
		if (imagePreview) {
			imagePreview.innerHTML = '';
		}

		// Reset file name and size display
		let uploadFileNameDashboard = vinModal.querySelector('#uploadFileNameDashboard');
		if (uploadFileNameDashboard) {
			uploadFileNameDashboard.innerHTML = '';
		}

		let uploadFileSizeDashboard = vinModal.querySelector('#uploadFileSizeDashboard');
		if (uploadFileSizeDashboard) {
			uploadFileSizeDashboard.innerHTML = '';
		}
	}

	function simulateRandomUpload() {
		// Add width to #vinImageUploadProgress to go to 96%
		let vinImageUploadProgress = vinModal.querySelector('#vinImageUploadProgress');
		let progress = 0; // Start from 0%
		const maxProgress = 96; // Maximum progress before stopping

		const uploadInterval = setInterval(() => {
			// Randomly increase progress by 1% to 5%
			const randomIncrease = Math.floor(Math.random() * 5) + 1;
			progress += randomIncrease;

			if (progress > maxProgress) {
				progress = maxProgress; // Ensure progress does not exceed maxProgress
			}

			vinImageUploadProgress.style.width = `${progress}%`;

			// Check if we've reached or exceeded the stopping point
			if (progress >= maxProgress) {
				clearInterval(uploadInterval); // Stop the simulated upload
			}
		}, 200); // Adjust time interval as needed
	}

	function openVinModal() {
		// add ai-modal-open on body
		document.body.classList.add('ai-modal-open-vin');
	}

	function closeVinModal() {
		document.body.classList.remove('ai-modal-open-vin');
	}

	(function () {
		let copyText = vinModal.querySelector('.js-copy-value');
		if (copyText) {
			copyText.addEventListener('click', function () {
				let text = copyText.querySelector('p').innerText;
				navigator.clipboard.writeText(text);
				copyText.classList.add('copied');
			});
		}
	})();

	function sendImageForVerification() {
		// Key added server side by the site's proxy.
		const endpoint = aiUrl('read');

		// Get the image element
		const imgElement = document.querySelector('#vinImagePreview img');
		const imgSrc = imgElement.src;

		// Function to convert base64 to Blob
		function base64ToBlob(base64, type = 'application/octet-stream') {
			const binaryString = window.atob(base64.split(',')[1]);
			const len = binaryString.length;
			const bytes = new Uint8Array(len);
			for (let i = 0; i < len; i++) {
				bytes[i] = binaryString.charCodeAt(i);
			}
			return new Blob([bytes], { type });
		}

		// Convert base64 image src to Blob
		const blob = base64ToBlob(imgSrc, 'image/jpeg');

		// Send the Blob to the prediction endpoint
		fetch(endpoint, {
			method: 'POST',
			headers: {
				'Content-Type': 'application/octet-stream',
			},
			body: blob,
		})
			.then((response) => response.json())
			.then((data) => {
				console.log('OCR Results:', data);

				// Extract and display caption
				let captionText = data.captionResult.text || '';
				let extractedText = `Caption: ${captionText}\n\n`;

				// Extract and display text from readResult
				if (data.readResult && data.readResult.blocks) {
					data.readResult.blocks.forEach((block) => {
						block.lines.forEach((line) => {
							extractedText += line.text + '\n';
						});
					});
				}
				// Check if extracted text is VIN
				const vinRegex = /[A-HJ-NPR-Z0-9]{17}/g;
				const vinMatches = extractedText.match(vinRegex);
				const vinNumber = vinMatches && vinMatches.length > 0 ? vinMatches[0] : null;

				vinModal.querySelector('.c-modal__uploader').classList.add('active');

				if (data.code === 'BadRequestImageFormat') {
					alert('Image format is not accepted. Please upload a valid image.');
				}

				if (vinNumber) {
					vinModal.querySelector('.c-modal__upload-status--uploading').classList.remove('active');
					vinModal.querySelector('.c-modal__upload-status--success').classList.add('active');
					vinModal.querySelector('.c-modal__upload-buttons--success').classList.add('active');

					// Add VIN to #vinNumber
					let vinNumberHolder = vinModal.querySelector('#vinNumber');
					vinNumberHolder.innerHTML = vinNumber;
					if(toolType === 'quote') {
						qtAnalytics('ai-vehicle-information-ai-upload-validation-confirmation-start', '', 4.4, toolType);
					}
					if(toolType === 'appointment') {
						qtAnalytics('ai-vehicle-information-ai-upload-validation-confirmation-start', '', 2.4, toolType);
					}
				} else {
					vinModal.querySelector('.c-modal__upload-status--uploading').classList.remove('active');
					vinModal.querySelector('.c-modal__upload-status--error').classList.add('active');
					vinModal.querySelector('.c-modal__upload-buttons--error').classList.add('active');
					vinModal.querySelector('.c-modal__uploader').classList.add('failed');
					vinModal.querySelector('.c-modal__uploader').classList.remove('active');

					if(toolType === 'quote') {
						qtAnalytics('ai-vehicle-information-ai-upload-validation-error-start', '', 4.4, toolType);
					}

					if(toolType === 'appointment') {
						qtAnalytics('ai-vehicle-information-ai-upload-validation-error-start', '', 2.4, toolType);
					}
				}
			})
			.catch((error) => {
				console.error('Error:', error);
				qtAnalytics('ai-vehicle-information-ai-upload-validation-error-start');
			});
	}

	// Function for showing/hiding steps where active one gets removed and the next one is shown
	function showStep(step) {
		let activeStep = vinModal.querySelector('.c-modal__upload.active');
		activeStep.classList.remove('active');
		vinModal.querySelector('.' + step).classList.add('active');
	}

	const goToStartButtons = vinModal.querySelectorAll('.js-go-to-start');

	if (goToStartButtons.length > 0) {
		goToStartButtons.forEach((goToStart) => {
			goToStart.addEventListener('click', function () {
				showStep(steps.start);
				resetModal();
				if(toolType === 'quote') {
					qtAnalytics('ai-vehicle-information-ai-submit', '', 4.1, toolType);
					qtAnalytics('ai-vehicle-information-ai-upload-start', '', 4.2), toolType;
				}
				if(toolType === 'appointment') {
					qtAnalytics('ai-vehicle-information-ai-submit', '', 2.1, toolType);
					qtAnalytics('ai-vehicle-information-ai-upload-start', '', 2.2, toolType);
				}

			});
		});
	}

	let goToUploading = vinModal.querySelector('.js-go-to-uploading');
	if (goToUploading) {
		goToUploading.addEventListener('click', function () {
			showStep(steps.uploading);
			if (toolType === 'quote') {
				qtAnalytics('ai-vehicle-information-ai-upload-validation-submit', '', 4.3, toolType);
			}
			if (toolType === 'appointment') {
				qtAnalytics('ai-vehicle-information-ai-upload-validation-submit', '', 2.3, toolType);
			}
			sendImageForVerification();
		});
	}

	let goToServices = vinModal.querySelector('.js-go-to-service-selector');
	if (goToServices) {
		goToServices.addEventListener('click', function () {
			showStep(steps.services);
		});
	}

	let closeVinModalClasses = vinModal.querySelectorAll('.js-close-modal');
	if (closeVinModalClasses) {
		closeVinModalClasses.forEach(function (trigger) {
			trigger.addEventListener('click', function () {
				closeVinModal();
			});
		});
	}

	// Press ESC to close modal
	document.addEventListener('keydown', function (e) {
		if (e.key === 'Escape') {
			closeVinModal();
		}
	});

	let closeAiModalTrigger = vinModal.querySelector('.js-close-modal-trigger-icon-select');
	if (closeAiModalTrigger) {
		closeAiModalTrigger.addEventListener('click', function () {
			let iconSelectButton = vinModal.querySelector('.js-qt-confirm-icon-select');
			iconSelectButton.click();
			closeVinModal();
		});
	}

	let openAiModalTrigger = vinModal.querySelector('.js-open-ai-vin-modal');
	if (openAiModalTrigger) {
		openAiModalTrigger.addEventListener('click', function () {
			openVinModal();
			showStep(steps.start);
		});
	}
	let goToStart = vinModal.querySelector('.js-go-to-start');
	if (goToStart) {
		goToStart.addEventListener('click', function () {
			console.log('Go to start');
			showStep(steps.start);
		});
	}

	vinImageUpload.addEventListener('change', function (e) {
		let file = e.target.files[0];
		let formData = new FormData();
		formData.append('file', file);

		if (toolType == 'quote') {
			qtAnalytics('ai-vehicle-information-ai-upload-submit','', 4.2, toolType);
		}
		if(toolType === 'appointment') {
			qtAnalytics('ai-vehicle-information-ai-upload-submit','', 2.2, toolType);
		}

		const reader = new FileReader();
		reader.onload = function (e) {
			const imagePreview = vinModal.querySelector('#vinImagePreview');
			imagePreview.innerHTML = '<img src="' + e.target.result + '" alt="Image preview" style="max-width: 100%; height: auto;"/>';

			// Get file name and size
			let fileName = file.name;
			let fileSize = file.size;

			// Add file name to #uploadFileName
			let uploadFileName = vinModal.querySelector('#uploadFileName');
			uploadFileName.innerHTML = fileName;

			// Add file size to #uploadFileSize
			let uploadFileSize = vinModal.querySelector('#uploadFileSize');
			//Convert bytes to KB
			let fileSizeInKB = fileSize / 1024;
			uploadFileSize.innerHTML = fileSizeInKB.toFixed(0) + ' KB';

			// Show the next step
			showStep(steps.verify);
			simulateRandomUpload();

			// Quote tool and 4.3 2.3
			if (toolType === 'quote') {
				qtAnalytics('ai-vehicle-information-ai-upload-validation-start', '', 4.3, toolType);
			}

			if (toolType === 'appointment') {
				qtAnalytics('ai-vehicle-information-ai-upload-validation-start', '', 2.3, toolType);
			}
		};
		reader.readAsDataURL(file);
	});
}
